const atualizarGruposProduto = (state, gruposProduto) => {
    state.gruposProduto = gruposProduto;
}

const atualizarSubGruposProduto = (state, subGruposProduto) => {
    state.subGruposProduto = subGruposProduto;
}

const atualizarGrupoProduto = (state, grupoProduto) => {
    state.grupoProduto = grupoProduto;
}

const atualizarSubGrupoProduto = (state, subGrupoProduto) => {
    state.subGrupoProduto = subGrupoProduto;
}

const addGrupoProduto = (state, grupoProduto) => {
    if (!grupoProduto || grupoProduto.id == null) return;

    state.gruposProduto.push(JSON.parse(JSON.stringify(grupoProduto)));
}

const updateGrupoProduto = (state, grupoProduto) => {
    if (!grupoProduto || grupoProduto.id == null) return;

    const index = state.gruposProduto.findIndex(item => item.id === grupoProduto.id);
    if (index >= 0) {
        state.gruposProduto.splice(index, 1, JSON.parse(JSON.stringify(grupoProduto)));
    }
}

const addSubGrupoProduto = (state, subGrupoProduto) => {
    if (!subGrupoProduto || subGrupoProduto.id == null) return;

    state.subGruposProduto.push(JSON.parse(JSON.stringify(subGrupoProduto)));
}

const updateSubGrupoProduto = (state, subGrupoProduto) => {
    if (!subGrupoProduto || subGrupoProduto.id == null) return;

    const index = state.subGruposProduto.findIndex(item => item.id === subGrupoProduto.id);
    if (index >= 0) {
        state.subGruposProduto.splice(index, 1, JSON.parse(JSON.stringify(subGrupoProduto)));
    }
}

export default {
    atualizarGruposProduto,
    atualizarGrupoProduto,
    atualizarSubGruposProduto,
    atualizarSubGrupoProduto,
    addGrupoProduto,
    updateGrupoProduto,
    addSubGrupoProduto,
    updateSubGrupoProduto
}
